import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const COUNTRIES = [
  "Côte d'Ivoire", "Sénégal", "Cameroun", "Mali", "Burkina Faso", "Guinée",
  "Bénin", "Togo", "Niger", "Congo", "Gabon", "Madagascar", "Mauritanie",
  "Tchad", "Centrafrique", "France", "Belgique", "Suisse", "Canada", "Autre",
];

const GRADES = ["Associé", "Manager", "Superviseur", "Senior", "Junior", "Stagiaire"];

interface Props {
  data: {
    first_name: string;
    last_name: string;
    profession: string;
    grade: string;
    email: string;
    country: string;
    phone: string;
  };
  orgType: "entreprise" | "cabinet" | null;
  onChange: (field: string, value: string) => void;
}

export function StepPersonalInfo({ data, orgType, onChange }: Props) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="first_name">Prénom <span className="text-destructive">*</span></Label>
          <Input
            id="first_name"
            value={data.first_name}
            onChange={(e) => onChange("first_name", e.target.value)}
            placeholder="Jean"
            required
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="last_name">Nom <span className="text-destructive">*</span></Label>
          <Input
            id="last_name"
            value={data.last_name}
            onChange={(e) => onChange("last_name", e.target.value)}
            placeholder="Dupont"
            required
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="email">Email professionnel <span className="text-destructive">*</span></Label>
        <Input
          id="email"
          type="email"
          value={data.email}
          onChange={(e) => onChange("email", e.target.value)}
          placeholder="jean.dupont@cabinet.com"
          required
        />
      </div>

      <div className={`grid gap-4 ${orgType === "cabinet" ? "grid-cols-2" : "grid-cols-1"}`}>
        <div className="space-y-2">
          <Label htmlFor="profession">Profession / Fonction <span className="text-destructive">*</span></Label>
          <Input
            id="profession"
            value={data.profession}
            onChange={(e) => onChange("profession", e.target.value)}
            placeholder="Ex: Expert-comptable, DAF..."
            required
          />
        </div>

        {orgType === "cabinet" && (
          <div className="space-y-2">
            <Label htmlFor="grade">Grade</Label>
            <Select value={data.grade} onValueChange={(v) => onChange("grade", v)}>
              <SelectTrigger id="grade">
                <SelectValue placeholder="Sélectionner..." />
              </SelectTrigger>
              <SelectContent>
                {GRADES.map((g) => (
                  <SelectItem key={g} value={g}>{g}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="country">Pays <span className="text-destructive">*</span></Label>
          <Select value={data.country} onValueChange={(v) => onChange("country", v)}>
            <SelectTrigger id="country">
              <SelectValue placeholder="Sélectionner..." />
            </SelectTrigger>
            <SelectContent>
              {COUNTRIES.map((c) => (
                <SelectItem key={c} value={c}>{c}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="phone">Téléphone</Label>
          <Input
            id="phone"
            value={data.phone}
            onChange={(e) => onChange("phone", e.target.value)}
            placeholder="+225 07 XX XX XX XX"
          />
        </div>
      </div>
    </div>
  );
}
